import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import ExternoDetalle from "../../types/ExternoDetalle";
import { readMessageBack } from "../../utils/readMessageBack";

export interface GetExternosDetalle {
  externosDetalle: Page<ExternoDetalle>;
  gettingExternosDetalle: boolean;
  gettingExternosDetalleError: string;
}

export interface GetExternoDetalle {
  externoDetalle: ExternoDetalle;
  gettingExternoDetalle: boolean;
  gettingExternoDetalleError: string;
}

interface State extends GetExternosDetalle, GetExternoDetalle {}

const initialState: State = {
  externosDetalle: null,
  gettingExternosDetalle: false,
  gettingExternosDetalleError: null,

  externoDetalle: null,
  gettingExternoDetalle: false,
  gettingExternoDetalleError: null
};

export default function externoDetalleReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  // Llamada a resolver de snapshot
  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(
  state: State = initialState,
  action: IAction
): Partial<State> {
  switch (action.type) {
    // CLEAR_EXTERNOS_DETALLE
    case actionTypes.CLEAR_EXTERNOS_DETALLE: {
      return {
        externosDetalle: null,
        externoDetalle: null
      };
    }

    // GET_EXTERNO_DETALLE_BY_ID_PERSONA (detalle individual)
    case `${actionTypes.GET_EXTERNO_DETALLE_BY_ID_PERSONA}_PENDING`: {
      return {
        gettingExternoDetalle: true,
        gettingExternoDetalleError: null
      };
    }
    case `${actionTypes.GET_EXTERNO_DETALLE_BY_ID_PERSONA}_REJECTED`: {
      return {
        externoDetalle: null,
        gettingExternoDetalle: false,
        gettingExternoDetalleError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_EXTERNO_DETALLE_BY_ID_PERSONA}_FULFILLED`: {
      return {
        externoDetalle: action.payload.data,
        gettingExternoDetalle: false,
        gettingExternoDetalleError: null
      };
    }

    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_ID_PERSONA}_PENDING`:
    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_CURP}_PENDING`:
    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_FILTERS}_PENDING`: {
      return {
        gettingExternosDetalle: true,
        gettingExternosDetalleError: null
      };
    }
    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_ID_PERSONA}_REJECTED`:
    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_CURP}_REJECTED`:
    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_FILTERS}_REJECTED`: {
      return {
        externosDetalle: null,
        gettingExternosDetalle: false,
        gettingExternosDetalleError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_ID_PERSONA}_FULFILLED`:
    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_CURP}_FULFILLED`:
    case `${actionTypes.GET_EXTERNOS_DETALLE_BY_FILTERS}_FULFILLED`: {
      return {
        externosDetalle: action.payload.data,
        gettingExternosDetalle: false,
        gettingExternosDetalleError: null
      };
    }

    default: {
      return state;
    }
  }
}
